var render = function render(_c,_vm){return _c('div',_vm._b({staticClass:"flex -mx-1 sm:-mx-2 xl:-mx-3",class:[
    _vm.data.class,
    _vm.data.staticClass,
    _vm.props.wrap ? 'flex-wrap' : 'flex-no-wrap',
  ]},'div',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }